import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Contact Us</h1>
      </div>
      <div className="contact-form-container">
        <form className="contact-form">
          <div className="contact-form-group">
            <label htmlFor="name" className="contact-form-label">Name</label>
            <input type="text" className="contact-form-control" id="name" required />
          </div>
          <div className="contact-form-group">
            <label htmlFor="email" className="contact-form-label">Email</label>
            <input type="email" className="contact-form-control" id="email" required />
          </div>
          <div className="contact-form-group">
            <label htmlFor="subject" className="contact-form-label">Subject</label>
            <input type="text" className="contact-form-control" id="subject" required />
          </div>
          <div className="contact-form-group">
            <label htmlFor="message" className="contact-form-label">Message</label>
            <textarea className="contact-form-control" id="message" rows="5" required></textarea>
          </div>
          <button type="submit" className="contact-form-button">Send</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
